import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { AssetOverlayOutlined } from '../Icons/AssetOverlayIcon';
import { StyledButton } from '../ImageViewer.style';

type AssetOverlayToolProps = {
  onChange: (data: any) => void;
  value?: boolean;
  disabled?: boolean;
};

export const AssetOverlayTool: React.FunctionComponent<AssetOverlayToolProps> = ({
  onChange,
  value = false,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const handleClick = useCallback(() => {
    onChange({ assetOverlay: !value });
  }, [value, onChange]);

  return (
    <StyledButton
      data-testid="image-controls-asset-overlay"
      title={t('images.assetOverlay', 'Asset Overlay')}
      type={value ? 'primary' : 'default'}
      onClick={handleClick}
      disabled={disabled}
      icon={<AssetOverlayOutlined />}
    />
  );
};
